export default __webpack_public_path__ + "static/media/header_1920_KMI_generica_web_sep20.d9c27353.png";